import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../Hooks/useToast";
import imageCompression from "browser-image-compression";

import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import FormLabel from "@mui/material/FormLabel";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import AlternativeHeader from "../../Components/Headres/Alternative_Header";
import FromikTextField from "../../Components/Utils/Formik_Texfiled";
import CustomButton from "../../Components/Utils/Custom_Btn";
import ExtraObjectsInput from "../../Components/Utils/ExtraObject_Formik";
import FormikAuto from "../../Components/Utils/Formik_Autocom";

import { FetchCreateReservations } from "../../Apis/Reservations/Reservations";
import { FetchCreateUser } from "../../Apis/Users/Create_User";
import { FetchUserDetails } from "../../Apis/Users/Get_User_Details";
import { fetchUsersAutocomplete } from "../../Redux/Users_Slice";
import { fetchPackegesAutocomplete } from "../../Redux/Package_AutoComplete";
import { fetchGetAllExtraObjectApi } from "../../Redux/ExtraObjects_Slice";
import { fetchReservations } from "../../Redux/Reservations_Slice";

const VisuallyHiddenInput = (props) => (
  <input style={{ display: "none" }} {...props} />
);

const AddBuchungen = () => {
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [dateOfReservation, setDateOfReservation] = useState(new Date());
  const [isCompressing, setIsCompressing] = useState(false);
  const [showAddUserModal, setShowAddUserModal] = useState(false);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [userCreationLoading, setUserCreationLoading] = useState(false);
  
  const navigate = useNavigate();
  const { toastSuccess, toastError } = useToast();
  const dispatch = useDispatch();
  const data = useSelector((item) => item.Users || []);
  const object = useSelector((item) => item.ExtraObjects || []);
  const packagename = useSelector((item) => item.PackegesAutocomplete || []);
  const reservations = useSelector((item) => item.Reservations || []);

  useEffect(() => {
    dispatch(fetchGetAllExtraObjectApi());
    dispatch(fetchPackegesAutocomplete({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
    dispatch(fetchReservations({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
    dispatch(fetchUsersAutocomplete({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
  }, [dispatch]);

  // تحديث البيانات عند التركيز على النافذة
  useEffect(() => {
    const handleFocus = () => {
      dispatch(fetchGetAllExtraObjectApi());
      dispatch(fetchPackegesAutocomplete({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
      dispatch(fetchReservations({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
      dispatch(fetchUsersAutocomplete({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
    };

    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [dispatch]);

  // تحديث البيانات كل 30 ثانية
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(fetchGetAllExtraObjectApi());
      dispatch(fetchPackegesAutocomplete({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
      dispatch(fetchReservations({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
      dispatch(fetchUsersAutocomplete({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
    }, 30000);

    return () => clearInterval(interval);
  }, [dispatch]);

  // User creation form
  const userFormik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      address: "",
      plz: "",
      city: "",
      password: "TempPassword123!",
      passwordConfirm: "TempPassword123!",
    },
    validate: (values) => {
      const errors = {};
      if (!values.firstName) errors.firstName = "Vorname ist erforderlich";
      if (!values.lastName) errors.lastName = "Nachname ist erforderlich";
      if (!values.email) errors.email = "E-Mail ist erforderlich";
      if (!values.phoneNumber) errors.phoneNumber = "Telefonnummer ist erforderlich";
      return errors;
    },
    onSubmit: async (values) => {
      try {
        setUserCreationLoading(true);
        
        // Combine address fields
        const fullAddress = `${values.address}, ${values.plz} ${values.city}`.trim();
        
        const userData = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          phoneNumber: values.phoneNumber,
          address: fullAddress,
          password: values.password,
          passwordConfirm: values.passwordConfirm,
        };

        const result = await FetchCreateUser(userData);
        
        if (result?.status === 201 || result?.status === 200) {
          toastSuccess("Benutzer wurde erfolgreich erstellt!");
          
          // Update both users and reservations to get the latest data
          dispatch(fetchUsersAutocomplete({ page: 1, limit: Number.MAX_SAFE_INTEGER || [] }));
          dispatch(fetchReservations({ page: 1, limit: Number.MAX_SAFE_INTEGER }));
          
          // Set the newly created user in the main form
          const fullName = `${values.firstName} ${values.lastName}`;
          formik.setFieldValue("userName", fullName);
          formik.setFieldValue("email", values.email);
          formik.setFieldValue("phoneNumber", values.phoneNumber);
          formik.setFieldValue("customerStreet", values.address);
          formik.setFieldValue("customerPLZ", values.plz);
          formik.setFieldValue("customerCity", values.city);
          
          // Close modal and reset form
          setShowAddUserModal(false);
          userFormik.resetForm();
        } else {
          const errorMsg = result?.error || "Benutzer konnte nicht erstellt werden.";
          toastError(errorMsg);
        }
      } catch (error) {
        const serverMessage = error?.response?.data?.message || error?.message || "Fehler beim Erstellen des Benutzers.";
        toastError(serverMessage);
      } finally {
        setUserCreationLoading(false);
      }
    },
  });

  const handleImageUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        setIsCompressing(true);
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        setSelectedImage(compressedFile);
        setImagePreview(URL.createObjectURL(compressedFile));
      } catch (error) {
        toastError("Bildkomprimierung fehlgeschlagen.");
      } finally {
        setIsCompressing(false);
      }
    }
  };

  const formik = useFormik({
    initialValues: {
      packageName: "",
      userName: "",
      email: "",
      phoneNumber: "",
      customerStreet: "",
      customerPLZ: "",
      customerCity: "",
      extraObjectsList: [],
      numberOfPersons: 1,
      payWay: "code",
      note: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.packageName) errors.packageName = "Package Name ist erforderlich";
      if (!values.userName) errors.userName = "Benutzername ist erforderlich";
      if (!values.email) errors.email = "E-Mail ist erforderlich";
      if (!values.phoneNumber) errors.phoneNumber = "Telefonnummer ist erforderlich";
      return errors;
    },
    onSubmit: async (values) => {
      try {
        if (!selectedImage) {
          toastError("Bitte laden Sie ein Bild hoch.");
          return;
        }

        setLoading(true);
        
        // التحقق من البيانات المطلوبة مع رسائل أكثر وضوحاً
        if (!values.userName || values.userName.trim() === "") {
          toastError("اسم العميل مطلوب - يرجى إدخال اسم العميل");
          setLoading(false);
          return;
        }
        
        if (!values.email || values.email.trim() === "") {
          toastError("الإيميل مطلوب - يرجى إدخال عنوان البريد الإلكتروني");
          setLoading(false);
          return;
        }
        
        if (!values.phoneNumber || values.phoneNumber.trim() === "") {
          toastError("رقم الهاتف مطلوب - يرجى إدخال رقم الهاتف");
          setLoading(false);
          return;
        }
        
        if (!values.packageName || values.packageName.trim() === "") {
          toastError("اسم الباكج مطلوب - يرجى اختيار باكج");
          setLoading(false);
          return;
        }
        
        const formData = new FormData();
        
        // التأكد من أن البيانات ليست فارغة قبل الإضافة
        const customerName = values.userName?.trim() || "";
        const customerEmail = values.email?.trim() || "";
        const customerPhone = values.phoneNumber?.trim() || "";
        
        formData.append("email", customerEmail);
        formData.append("customerEmail", customerEmail);
        formData.append("customerName", customerName);
        formData.append("customerPhone", customerPhone);
        formData.append("customerStreet", values.customerStreet || "");
        formData.append("customerPLZ", values.customerPLZ || "");
        formData.append("customerCity", values.customerCity || "");
        formData.append("packageName", values.packageName);

        values.extraObjectsList.forEach((item, index) => {
          formData.append(`extraObjectsList[${index}][name]`, item.name || null);
          formData.append(`extraObjectsList[${index}][price]`, item.price || 0);
          formData.append(`extraObjectsList[${index}][number]`, item.number || 1);
        });

        formData.append("numberOfPersons", values.numberOfPersons);
        formData.append("payWay", values.payWay);
        formData.append("note", values.note || "");
        formData.append("isAGift", false);
        formData.append("selectedGender", "");
        
        if (selectedImage) {
          formData.append("codePhotos", selectedImage);
        }

        if (dateOfReservation) {
          const isoStringWithoutTimezone = new Date(
            dateOfReservation.getTime() - (dateOfReservation.getTimezoneOffset() * 60000)
          ).toISOString();
          formData.append("dateOfReservation", isoStringWithoutTimezone);
        }

        const result = await FetchCreateReservations(formData);
        
        if (result?.status === 201) {
          toastSuccess("Die Reservierung wurde erfolgreich erstellt!");
          navigate("/");
        } else {
          const errorMsg = result?.data?.message || result?.message || "Die Erstellung der Reservierung ist fehlgeschlagen.";
          toastError(errorMsg);
        }
      } catch (error) {
        const serverMessage = error?.response?.data?.message || error?.message || "Während der Übermittlung ist ein Fehler aufgetreten.";
        toastError(serverMessage);
      } finally {
        setLoading(false);
      }
    },
  });

  // Handle user selection
  const handleUserSelection = (event, selectedOption) => {
    if (selectedOption) {
      formik.setFieldValue("userName", selectedOption.value);
      formik.setFieldValue("email", selectedOption.email || "");
      formik.setFieldValue("phoneNumber", selectedOption.phoneNumber || "");
      formik.setFieldValue("customerStreet", selectedOption.customerStreet || "");
      formik.setFieldValue("customerPLZ", selectedOption.customerPLZ || "");
      formik.setFieldValue("customerCity", selectedOption.customerCity || "");
      setSelectedUserName(selectedOption.value);
    } else {
      formik.setFieldValue("userName", "");
      formik.setFieldValue("email", "");
      formik.setFieldValue("phoneNumber", "");
      formik.setFieldValue("customerStreet", "");
      formik.setFieldValue("customerPLZ", "");
      formik.setFieldValue("customerCity", "");
      setSelectedUserName("");
    }
  };

  // Handle user input in autocomplete (when user types a name that doesn't exist)
  const handleUserInputChange = (event, value, reason) => {
    if (reason === 'input' && value && value.trim() !== '') {
      // Check if the typed value matches any existing user
      const userExists = userOptions.some(user => 
        user.label.toLowerCase().includes(value.toLowerCase()) ||
        (user.email && user.email.toLowerCase().includes(value.toLowerCase()))
      );
      
      // If user doesn't exist
      if (!userExists) {
        // Use a timeout to avoid showing modal immediately while user is still typing
        setTimeout(() => {
          // Double check if the field still has the same value and user hasn't selected anything
          if (formik.values.userName === value && !formik.values.email && !formik.values.phoneNumber) {
            // Check if it looks like an email
            const isEmail = value.includes('@');
            
            if (isEmail) {
              // If it's an email, set it in the email field of user creation form
              userFormik.setFieldValue('email', value);
              userFormik.setFieldValue('firstName', '');
              userFormik.setFieldValue('lastName', '');
              userFormik.setFieldValue('phoneNumber', '');
              userFormik.setFieldValue('address', '');
              userFormik.setFieldValue('plz', '');
              userFormik.setFieldValue('city', '');
            } else {
              // If it's a name, split it into first and last name
              const nameParts = value.trim().split(' ');
              const firstName = nameParts[0] || '';
              const lastName = nameParts.slice(1).join(' ') || '';
              
              userFormik.setFieldValue('firstName', firstName);
              userFormik.setFieldValue('lastName', lastName);
              userFormik.setFieldValue('email', '');
              userFormik.setFieldValue('phoneNumber', '');
              userFormik.setFieldValue('address', '');
              userFormik.setFieldValue('plz', '');
              userFormik.setFieldValue('city', '');
            }
            
            // Show the add user modal
            setShowAddUserModal(true);
            
            // Clear the main form field temporarily
            formik.setFieldValue("userName", "");
          }
        }, 1500); // Wait 1.5 seconds after user stops typing
      }
    }
  };

  // Prepare user options for autocomplete
  const userOptions = React.useMemo(() => {
    const uniqueCustomers = new Map();
    
    // Add customers from reservations first (higher priority)
    if (reservations?.data && Array.isArray(reservations.data)) {
      reservations.data.forEach((reservation) => {
        let fullName = '';
        let email = '';
        
        if (reservation.customerName && reservation.customerName.trim() !== '') {
          fullName = reservation.customerName.trim();
        } else if (reservation.userName && reservation.userName.trim() !== '') {
          fullName = reservation.userName.trim();
        }
        
        email = reservation.customerEmail || reservation.email || '';
        const phoneNumber = reservation.customerPhone || '';
        const customerStreet = reservation.customerStreet || '';
        const customerPLZ = reservation.customerPLZ || '';
        const customerCity = reservation.customerCity || '';
        
        if (fullName && fullName.length > 0) {
          const uniqueKey = `${fullName.toLowerCase()}_${email.toLowerCase()}`;
          
          if (!uniqueCustomers.has(uniqueKey)) {
            uniqueCustomers.set(uniqueKey, {
              id: `customer_${reservation.userId || Math.random()}_${Date.now()}`,
              label: fullName,
              value: fullName,
              email: email,
              phoneNumber: phoneNumber,
              customerStreet: customerStreet,
              customerPLZ: customerPLZ,
              customerCity: customerCity,
              source: 'reservation',
              priority: 1
            });
          }
        }
      });
    }
    
    // Add registered users (lower priority)
    if (data?.data?.data && Array.isArray(data.data.data)) {
      data.data.data.forEach((user) => {
        if (user.firstName && user.lastName) {
          const fullName = `${user.firstName} ${user.lastName}`.trim();
          const email = user.email || '';
          const phoneNumber = user.phoneNumber || '';
          // استخراج بيانات العنوان من حقل address المدمج
          const addressParts = (user.address || '').split(',');
          const customerStreet = addressParts[0]?.trim() || '';
          const cityPart = addressParts[1]?.trim() || '';
          const cityParts = cityPart.split(' ');
          const customerPLZ = cityParts[0] || '';
          const customerCity = cityParts.slice(1).join(' ') || '';
          
          const uniqueKey = `${fullName.toLowerCase()}_${email.toLowerCase()}`;
          
          if (fullName && !uniqueCustomers.has(uniqueKey)) {
            uniqueCustomers.set(uniqueKey, {
              id: `registered_${user._id || user.id}_${Date.now()}`,
              label: fullName,
              value: fullName,
              email: email,
              phoneNumber: phoneNumber,
              customerStreet: customerStreet,
              customerPLZ: customerPLZ,
              customerCity: customerCity,
              source: 'registered',
              priority: 2
            });
          }
        }
      });
    }
    
    // Convert Map to Array and sort by priority
    return Array.from(uniqueCustomers.values()).sort((a, b) => a.priority - b.priority);
  }, [reservations?.data, data?.data?.data]);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box ml={2} component="form" onSubmit={formik.handleSubmit}>
        <AlternativeHeader onPrevious={() => navigate("/")} title="Buchungsdetails" />
        <Box mt={6}>
          <Grid container spacing={4}>
            <Grid mt={0.2} size={4}>
              <FormLabel sx={{ fontStyle: "inherit", color: "#000000" }}>
                Reservierungsdatum
              </FormLabel>
              <DateTimePicker
                minutesStep={30}
                sx={{
                  width: "100%",
                  bgcolor: "white",
                  mt: 1,
                  borderRadius: "12px",
                  '& .MuiClock-root': { display: 'none' },
                  '& .MuiTypography-root': { display: 'none' }
                }}
                value={dateOfReservation}
                onChange={(newValue) => setDateOfReservation(newValue)}
                minDateTime={new Date()}
                ampm={false}
                format="HH:mm.dd.MM.yyyy "
                renderInput={(params) => (
                  <FromikTextField 
                  formik={formik} 
                  name="dateOfReservation" 
                  {...params} 
                  fullWidth 
                  />
                )}
              />
            </Grid>

            <Grid size={4}>
              <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: 1 }}>
                <Box sx={{ flex: 1 }}>
                  <FormikAuto
                    formik={formik}
                    name="userName"
                    label="Benutzername"
                    options={userOptions}
                    onChange={handleUserSelection}
                    onInputChange={handleUserInputChange}
                    freeSolo={true}
                    getOptionLabel={(option) => {
                      if (typeof option === 'string') return option;
                      return option?.label || option?.value || '';
                    }}
                    renderOption={(props, option) => (
                      <Box component="li" {...props} key={option.id}>
                        <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                              {option.label}
                            </Typography>
                            <Typography variant="caption" sx={{ 
                              color: option.source === 'reservation' ? 'primary.main' : 'secondary.main',
                              fontSize: '0.7rem'
                            }}>
                              ({option.source === 'reservation' ? 'Kunde' : 'Registriert'})
                            </Typography>
                          </Box>
                          {option.email && (
                            <Typography variant="caption" color="textSecondary">
                              📧 {option.email}
                            </Typography>
                          )}
                          {option.phoneNumber && (
                            <Typography variant="caption" color="textSecondary">
                              📞 {option.phoneNumber}
                            </Typography>
                          )}
                          {(option.customerStreet || option.customerPLZ || option.customerCity) && (
                            <Typography variant="caption" color="textSecondary">
                              🏠 {[option.customerStreet, option.customerPLZ, option.customerCity].filter(Boolean).join(', ')}
                            </Typography>
                          )}
                        </Box>
                      </Box>
                    )}
                  />
                </Box>
                <Button
                  variant="outlined"
                  onClick={() => setShowAddUserModal(true)}
                  sx={{
                    minWidth: 'auto',
                    px: 2,
                    py: 1.5,
                    borderColor: '#D6B981',
                    color: '#D6B981',
                    '&:hover': {
                      borderColor: '#D6B981',
                      backgroundColor: 'rgba(214, 185, 129, 0.1)',
                    }
                  }}
                >
                  + Benutzer
                </Button>
              </Box>
            </Grid>

            <Grid size={4}>
              <FromikTextField 
                formik={formik} 
                name="email" 
                label="E-Mail" 
                placeholder="z.B. example@email.com" 
                type="email" 
              />
            </Grid>

            <Grid size={4}>
              <FromikTextField 
                formik={formik} 
                name="phoneNumber" 
                label="Telefonnummer" 
                placeholder="z.B. +49 123 456789" 
                type="tel" 
              />
            </Grid>

            <Grid size={4}>
              <FromikTextField 
                formik={formik} 
                name="customerStreet" 
                label="Straße und HausNr" 
                placeholder="z.B. Musterstraße 123" 
              />
            </Grid>

            <Grid size={4}>
              <FromikTextField 
                formik={formik} 
                name="customerPLZ" 
                label="PLZ" 
                placeholder="z.B. 12345" 
              />
            </Grid>

            <Grid size={4}>
              <FromikTextField 
                formik={formik} 
                name="customerCity" 
                label="Stadt" 
                placeholder="z.B. Berlin" 
              />
            </Grid>

            <Grid size={4}>
              <FormikAuto
                formik={formik}
                name="packageName"
                label="Package Name"
                options={"data" in packagename.data ? packagename.data.data.map(pkg => ({
                  label: pkg.name,
                  value: pkg.name
                })) : []}
              />
            </Grid>

            <Grid size={4}>
              <FromikTextField 
                formik={formik} 
                name="numberOfPersons" 
                label="Anzahl der Personen" 
                placeholder="z.B. 2" 
                type="number" 
              />
            </Grid>

            <Grid size={4}>
              <FromikTextField 
                formik={formik} 
                name="payWay" 
                label="Zahlungsmethode" 
                placeholder="z.B. Code" 
                select
              >
                <MenuItem value="code">Code</MenuItem>
                <MenuItem value="paypal">PayPal</MenuItem>
              </FromikTextField>
            </Grid>

            <Grid size={12}>
              <Typography variant="subtitle1" gutterBottom>
                Extras buchung
              </Typography>
              <ExtraObjectsInput formik={formik} extraObjects={object?.data || []} />
            </Grid>

            <Grid size={12}>
              <Box
                sx={{
                  display: "flex",
                  width: { md: "200px" },
                  height: { xs: "300px", md: "200px" },
                  border: "2px solid #D6B981",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "12px",
                }}
              >
                {imagePreview ? (
                  <img
                    src={imagePreview}
                    alt="preview"
                    style={{ width: "90%", height: "90%", objectFit: "cover" }}
                  />
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    Kein Bild hochgeladen
                  </Typography>
                )}
              </Box>
              <Button
                sx={{ ml: 1.8, mt: 3 }}
                component="label"
                variant="contained"
                style={{ backgroundColor: "#D6B981" }}
                startIcon={<CloudUploadIcon />}
                disabled={isCompressing}
              >
                {isCompressing ? "Komprimierung läuft..." : "Bild hochladen"}
                <VisuallyHiddenInput
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  disabled={isCompressing}
                />
              </Button>
            </Grid>

            <Grid size={12}>
              <FromikTextField 
                formik={formik} 
                name="note" 
                label="Notiz" 
                placeholder="z.B. Es ist gut" 
                multiline
                rows={6}
              />
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ mt: 4, bgcolor: "#000000" }} />

        <Box mt={2} display="flex" justifyContent="flex-end">
          <CustomButton
            onNavigate={formik.handleSubmit}
            title="Speichern"
            disabled={loading || isCompressing}
          />
        </Box>

        {/* Add User Modal */}
        <Dialog 
          open={showAddUserModal} 
          onClose={() => {
            setShowAddUserModal(false);
            userFormik.resetForm();
          }}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Neuen Benutzer hinzufügen</DialogTitle>
          <DialogContent>
            <Box component="form" sx={{ mt: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FromikTextField
                    formik={userFormik}
                    name="firstName"
                    label="Vorname *"
                    placeholder="Vorname eingeben"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <FromikTextField
                    formik={userFormik}
                    name="lastName"
                    label="Nachname *"
                    placeholder="Nachname eingeben"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <FromikTextField
                    formik={userFormik}
                    name="email"
                    label="E-Mail-Adresse *"
                    placeholder="E-Mail eingeben"
                    type="email"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <FromikTextField
                    formik={userFormik}
                    name="phoneNumber"
                    label="Telefonnummer *"
                    placeholder="Telefonnummer eingeben"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <FromikTextField
                    formik={userFormik}
                    name="address"
                    label="Straße und HausNr"
                    placeholder="Straße und Hausnummer eingeben"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <FromikTextField
                    formik={userFormik}
                    name="plz"
                    label="PLZ"
                    placeholder="Postleitzahl eingeben"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <FromikTextField
                    formik={userFormik}
                    name="city"
                    label="Stadt"
                    placeholder="Stadt eingeben"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button 
              onClick={() => {
                setShowAddUserModal(false);
                userFormik.resetForm();
              }}
              disabled={userCreationLoading}
            >
              Abbrechen
            </Button>
            <Button 
              onClick={userFormik.handleSubmit}
              variant="contained"
              disabled={userCreationLoading}
              sx={{ backgroundColor: "#D6B981" }}
            >
              {userCreationLoading ? "Wird erstellt..." : "Benutzer erstellen"}
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </LocalizationProvider>
  );
};

export default AddBuchungen;
